import { render, staticRenderFns } from "./ProjectWebsiteEditPartnersTab.vue?vue&type=template&id=1d7b89aa"
import script from "./ProjectWebsiteEditPartnersTab.vue?vue&type=script&lang=ts"
export * from "./ProjectWebsiteEditPartnersTab.vue?vue&type=script&lang=ts"
import style0 from "./ProjectWebsiteEditPartnersTab.vue?vue&type=style&index=0&id=1d7b89aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports